module.exports = __webpack_public_path__ + "static/media/page-left.93dfa0f9.png";